<template>
    <v-container  v-if="item">
    <field-form :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep"  :saving="saving" @save="save">
    <h2 class="text-h4">{{$t('companies.business.title')}}</h2>
     <form-section type="optional" class="my-5">
        <v-text-field id="pfid1618820442" style="max-width:800px" :label="$t('companies.crNo')"
            v-model="fields.crNo"
        ></v-text-field>
        <!-- <v-switch label="The company is a VAT Payer" v-model="fields.vatPayer" /> -->
        <v-btn id="pfid1618820451" v-if="hasRegistrarAPI"
            @click="autofill" 
            color="primary" 
            :loading="loading">{{$t('companies.business.fillIn')}}</v-btn>
    </form-section>
    
    <form-section type="required" class="my-5">
    <v-text-field id="pfid1618820458" style="max-width:800px" prepend-icon="$company" :label="$t('common.name')" :rules="[rules.required]" v-model="fields.name" />
    <v-text-field id="pfid1618820462" style="max-width:800px" prepend-icon="$mailing" :label="$t('companies.business.email')" :rules="[rules.required, rules.email]" v-model="fields.email" />
    <v-text-field id="pfid1620749730"  style="max-width:800px" prepend-icon="$phone" :label="$t('companies.business.phone')" :rules="[rules.required, rules.phone]" v-model="fields.phone" />
    <v-text-field id="pfid1618820465" style="max-width:800px" prepend-icon="$street" :label="$t('companies.business.street')" :rules="[rules.required]" v-model="fields.street" />
    <v-text-field id="pfid1618820467" style="max-width:800px" prepend-icon="$city" :label="$t('companies.business.city')" :rules="[rules.required]" v-model="fields.city" />
    <v-text-field id="pfid1618820470" style="max-width:800px" prepend-icon="$zip" :label="$t('companies.business.zip')" :rules="[rules.required]" v-model="fields.zip" />
    <v-select id="pfid1618820474" style="max-width:800px" prepend-icon="$country" :label="$t('companies.country')" :items="countries" :rules="[rules.required]" v-model="fields.country"/>
    <v-switch id="pfid1619187822" :label="$t('companies.vatPayer')" v-model="fields.vatPayer" />
    <v-text-field id="pfid1618820446" style="max-width:800px" :label="$t('companies.vatNo')"
            v-model="fields.vatNo"
            :disabled="!fields.vatPayer"
            :rules="[v => !fields.vatPayer || !!v || $t('form.rules.required')]"
        ></v-text-field>
    </form-section>
    </field-form>
    </v-container>
    <v-skeleton-loader v-else type="article, actions" />
</template>
<script>

import EntityForm from '@/mixins/entity-form'
import Countries from '@/mixins/countries'
import Wizards from '@/mixins/wizards'

export default {
    name: 'Business',
    mixins: [EntityForm, Countries, Wizards],
    data() {
        return {
            loading: false,
            endpoint: 'companies',
            fields: {
                'crNo': null,
                'vatNo': null,
                'vatPayer': null,
                'email': null,
                'phone': null,
                'name': null,
                'street': null,
                'city': null,
                'zip': null,
                'country': null
            },
        };
    },
    computed: {
        hasRegistrarAPI() {
            return this.fields.country == 'CZ';
        }
    },
    watch: {
    },
    methods: {
        // called by the entity form
        afterFieldsLoad() {
            if(this.wizard && this.fields.crNo && !this.fields.name){
                this.autofill();
            }
        },
        autofill() {
            this.loading = true;
            this.$store.dispatch('companies/getRegistrarInfo', { crNo: this.fields.crNo, /* vatPayer: this.fields.vatPayer, */ country: this.fields.country }).then(info => { this.loading = false; Object.assign(this.fields, info)});
        }
    }
}
</script>